/**
 * Met en forme le champ `activity_area` d'une coiffeuse pour un affichage court.
 *
 * La donnée est saisie librement et arrive sale : plusieurs zones collées par
 * des `_`, une virgule en tête, parfois une adresse postale complète plutôt
 * qu'une ville. On ne garde que la première zone, réduite à « Ville, Province ».
 *
 * Exemples réels de la prod :
 *   "Montreal, QC, Canada_Lachine, Montreal, QC, Canada"        → "Montreal, QC"
 *   ",Saint-Jérôme, QC, Canada_Mirabel, QC, Canada"             → "Saint-Jérôme, QC"
 *   "Coop Sainte-Joséphine (…, 347 Bd Saint-Joseph #312, Gatineau, QC J8Y 3Z3, Canada"
 *                                                               → "Gatineau, QC"
 */
const COUNTRY_TOKENS: string[] = ['canada', 'usa', 'united states', 'états-unis', 'etats-unis'];
const POSTAL_CODE = /\s+[A-Z]\d[A-Z]\s*\d[A-Z]\d\s*$/i;

export function formatActivityArea(rawArea?: string): string {
  if (!rawArea) return '';

  const firstZone: string = rawArea.split('_').map(zone => zone.trim()).find(zone => !!zone) ?? '';

  const parts: string[] = firstZone
    .split(',')
    .map(part => part.replace(POSTAL_CODE, '').trim())
    .filter(part => !!part && !COUNTRY_TOKENS.includes(part.toLowerCase()));

  // Les deux derniers segments portent la ville et la province, que la saisie
  // soit une simple ville ou une adresse complète.
  return parts.slice(-2).join(', ');
}
